<nmo-simple-header></nmo-simple-header>

<div class="main-wrap">
  <nmo-video-container-v2 [defaultVideo]="defaultVideo" [groups]="videoGroups" *ngIf="videoGroups" (groupChange)="trackVideoContainerSlideChange($event)"></nmo-video-container-v2>
</div>

<nmo-simple-footer></nmo-simple-footer>
